// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n0-1";
export var messageSideRight = "_n0-2";
export var orderLookupBubbleContainer = "_n0-0";
export var submitButton = "_n0-3";